import { http } from "@/communication";

export const manualBackupModule = {
  namespaced: true,
  state: {
    manualBackup: false
  },
  actions: {
    read({ commit }) {
      return http
        .get("/api/v1/manualBackup")
        .then(({ data }) => {
          commit("update", data);
        })
        .catch(error => {
          console.log(`${name}s error`, error);
        });
    }
  },
  mutations: {
    update(state, data) {
      state.manualBackup = data;
    }
  },
  getters: {
    manualBackup: state => state.manualBackup
  }
};
